import { hasSupabaseConfig, supabase } from '../../../shared/api/supabaseClient.js';

function requireClient() {
  if (!hasSupabaseConfig || !supabase) throw new Error('Supabase 환경 변수가 설정되지 않았습니다.');
  return supabase;
}

function legacyElementRows(rows = []) {
  return rows.map((row) => ({
    icon_type: 'element',
    icon_key: String(row.icon_key || row.element_code || row.element || '').trim(),
    label: String(row.element || '').trim(),
    image_url: row.image_url,
    image_data: row.image_data,
    aliases: [row.element, row.element_code].filter(Boolean),
    metadata: { source: 'element_icons' },
    active: true,
  }));
}

export async function loadNikkeIconCatalog() {
  const client = requireClient();
  const result = await client
    .from('nikke_icon_catalog')
    .select('icon_type,icon_key,label,image_url,image_data,aliases,metadata,active')
    .eq('active', true)
    .order('icon_type', { ascending: true })
    .order('icon_key', { ascending: true })
    .limit(5000);
  if (!result.error) return result.data || [];

  // The previous element catalog remains available until the migration is applied.
  if (result.error.code === '42P01' || /nikke_icon_catalog/i.test(result.error.message || '')) {
    const legacy = await client
      .from('element_icons')
      .select('element,element_code,icon_key,image_url,image_data')
      .order('element', { ascending: true });
    if (!legacy.error) return legacyElementRows(legacy.data || []);
  }
  throw new Error(`공용 니케 아이콘을 불러오지 못했습니다: ${result.error.message}`);
}
